<template>
  <div class="news" v-title data-title="广东多对多物联集团股份有限公司">
    <div class="newsList container">
      <ul>
        <li
          class="item row"
          @click="toContent(item.id)"
          v-for="(item, index) in newsList"
          :key="index"
        >
          <div class="newsImg col-sm-5">
            <img :src="item.thumb" alt="多对多物联平台" />
          </div>
          <div class="newsCont col-sm-7">
            <div class="newstit">{{ item.title }}</div>
            <div class="newsTime">{{ item.create_time }}</div>
            <div class="line"></div>
            <div class="text">{{ item.description }}</div>
          </div>
        </li>
      </ul>
      <div class="page page_el-pagination">
        <el-pagination
          layout="prev, pager, next"
          :total="count"
          @prev-click="prevPage"
          :page-size="pageSize"
          @next-click="nextPage"
          @current-change="toPage"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  metaInfo: {
    meta: [
      {
        name: "keywords",
        content:
          "多对多物联集团、银发经济、人口老龄化、心脑血管、慢性疾病、血压高、血糖、体脂管理、中医馆、养生馆、健康管理师、科学工作站、公益行动、老年产品目录、健康机构、客户管理、拓客、医保社保、养生保健、远程管理",
      },
      {
        name: "discription",
        content:
          "多对多物联集团是一家深耕于大健康领域多年的健康管理数智服务商，是华为战略合作伙伴，华为健康数据与多对多实现互联互通。多对多健康管理 SaaS 系统和健康管理拓客赢利AI解决方案，为用户建立健康档案，提供健康 AI 管理。业务涵盖医院、养老机构、社区中心、康养中心、养老院、中医馆、养生馆等。针对人口老龄化现状和银发经济趋势，多对多加入了科学健康指导工作站，百城千镇家庭防大病数智服务健康公益行动办公室。开放专业健康管理师进驻，实现合作加盟共赢。",
      },
    ],
  },
  data() {
    return {
      pageIndex: 1,
      newsList: [],
      //总条数
      count: 0,
      //一页条数
      pageSize: 6,
    };
  },
  mounted() {
    this.getNews();
  },
  watch: {
    $route(to, from) {
      //路由参数发生改变，触发事件
      this.getNews();
    },
  },
  methods: {
    //页数跳转
    toPage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getNews();
    },
    //上一页
    prevPage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getNews();
    },
    //下一页
    nextPage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getNews();
    },
    //跳转至新闻内容页
    toContent(id) {
      this.$router.push({
        path: "/newsContent/" + id,
        params: { id },
      });
    },
    //获取新闻列表数据
    getNews() {
      let keyboard = this.$route.query.keyboard;
      if (keyboard) {
        keyboard = keyboard;
      } else {
        keyboard = "";
      }

      this.sendHttp({
        url: this.baseUrl + "/article/newslist",
        method: "post",
        data: {
          alias: "www",
          key: keyboard,
          page: this.pageIndex,
        },
      }).then((res) => {
        if (res.code == "0") {
          //console.log(res);
          this.newsList = res.data;
          this.count = res.count;
          //推荐新闻发布时间取年月日
          for (let i = 0; i < res.data.length; i++) {
            let time = res.data[i].create_time;
            let createTime = [];
            createTime = time.split(" ");
            this.newsList[i].create_time = createTime[0];
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.page {
  display: flex;
  justify-content: center;
  padding-top: 40px;
}
.news {
  padding: 100px 0;
  box-shadow: 0 10px 10px -3px #ffeeee;
  @media (max-width: 768px) {
    padding: 50px 0;
  }
  .newsList {
    @media (max-width: 992px) {
      max-width: 90%;
    }
    @media (max-width: 576px) {
      max-width: 100%;
    }
    ul {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        cursor: default;
        width: 45%;
        @media (max-width: 992px) {
          width: 48%;
          height: 120px;
        }
        @media (max-width: 768px) {
          width: 90%;
          margin: 0 auto;
          margin-bottom: 40px;
        }
        @media (max-width: 576px) {
          width: 90%;
          height: 300px;
          .newsImg {
            height: 60%;
            overflow-y: hidden;
          }
        }
        display: flex;
        justify-content: space-between;
        background: #fff;
        font-size: 8px;
        line-height: 15px;
        margin-bottom: 40px;
        box-shadow: #d9d9d9 0px 0px 10px;
        height: 160px;
        overflow: hidden;
        .line {
          background: #b5b5b5;
          width: 50px;
          margin: 6px 0;
          height: 2px;
        }
        .newsImg {
          padding: 0;
          background: #eee;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .newsCont {
          text-align: left;
          padding: 15px 10px;
          color: #9fa0a0;
          font-size: 14px;
          line-height: 17px;
          .newstit {
            color: #020304;
            font-size: 18px;
            font-weight: bold;
            height: 18px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .newsTime {
            padding-top: 4px;
          }
          .text {
            height: 68px;
            overflow: hidden;
            font-size: 16px;
            @media (max-width: 992px) {
              height: 36px;
            }
          }
        }
        &:hover {
          .tit {
            color: #ee8835;
          }
          .newsCont {
            .newstit {
              color: #ee8835;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/news.vue